import React from 'react';
import { SvgPlaceholder } from './SvgPlaceholder';

type FallbackProps<Name extends string | number | symbol> = {
    name: Name;
} & React.SVGProps<SVGSVGElement>;

export function createSvgComponent<
    T extends Record<
        string,
        React.ComponentType<React.SVGProps<SVGSVGElement>>
    >,
>(registry: T) {
    type Name = keyof T;
    type Props = { name: Name } & React.SVGProps<SVGSVGElement>;

    const SvgComponent: React.FC<Props> = ({ name, ...props }) => {
        const Comp = registry[name] as
            | React.ComponentType<React.SVGProps<SVGSVGElement>>
            | undefined;

        if (!Comp) {
            const { className, style, ...rest } = props as FallbackProps<Name>;
            return (
                <SvgPlaceholder
                    className={className}
                    style={style}
                    role={rest.role as string | undefined}
                    aria-hidden={rest['aria-hidden']}
                >
                    ?
                </SvgPlaceholder>
            );
        }

        return <Comp {...props} />;
    };

    return SvgComponent;
}
